export const MLawyerMenu = () => [
    { MenuName: "Dashboard", subMenu: [] },
    { MenuName: "Advocate", subMenu: [] },
    { MenuName: "Requests", subMenu: [] },
    { MenuName: "Complaints", subMenu: [] },
    { MenuName: "Customer", subMenu: [] },
    { MenuName: "Support", subMenu: [] },
    {MenuName:"Consultations",subMenu:[]},
    { MenuName: "Transactions", subMenu: [] },
    { MenuName: "GstInvoice", subMenu: [] },
    { MenuName: "Penalty", subMenu: [] },
    { MenuName: "Coupon", subMenu: [] },
    { MenuName: "Config", subMenu: [] },
    { MenuName: "AccessController", subMenu: [] },
    { MenuName: "User", subMenu: [] },
];